import { adminStatsQueries } from "$/lib/queries/admin-stats-queries"
import { statsSearchSchema } from "$/lib/stats-search"
import { createFileRoute, retainSearchParams } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/ab-tests")({
  validateSearch: statsSearchSchema,
  search: {
    middlewares: [retainSearchParams(["storeIds"])],
  },
  loader: async ({ context: { queryClient } }) => {
    await queryClient.ensureQueryData(adminStatsQueries.stores())
    return { crumb: "A/B-tester" }
  },
})
